import { render, staticRenderFns } from "./CirclePlusIcon.vue?vue&type=template&id=242c8dde&scoped=true"
import script from "./CirclePlusIcon.vue?vue&type=script&lang=js"
export * from "./CirclePlusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242c8dde",
  null
  
)

export default component.exports